<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">招标文件审核会签表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回合同详情</a>
    </div>
    <div class="form-content" v-if="contract.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">

          <el-form-item label="需求类型">
            <el-radio-group v-model="form.type" class="type-radio-type">
              <el-radio-button label="0">集团审批</el-radio-button>
              <el-radio-button label="1">子公司内部审批</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <create-invite-approval ref="create" :project="contract" :userData="userData" :formByFather="form">
          </create-invite-approval>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='10'></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createcontract()" class="form-btn" type="success">确认提交项目招标文件审批
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'
  import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItem from '@/components/ApprovalItem'
  import CreateInviteApproval from '@/page/form/createInviteApproval'
  export default {
    components: {
      ApprovalItem,
      CreateInviteApproval,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        tableData: [],

        contract: {},
        form: {
          contractId: '',
          dldw: "",
          content: "",
          mode: "",

          // 是否线下审批通过
          underLine: "",

          type: 0
        },
        approvalUsersData: [],

        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
      }
    },
    created() {
      this.getApplyData()
    },
    mounted() {
      this.form.contractId = this.$route.params.contractId
      this.getcontract()
      this.approvalUsersData = this.approvalUsers['c30_' + this.form.type]
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.form.signId = this.$route.params.applyId
        if (this.form.signId) {
          this.formLoading = true
          this.getcontractApplyInfo()
        } else {
          this.setSelectArr(this.applyInfo, 30, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getcontractApplyInfo() {
        ajax.get('/gc/project/invitesign/info/' + this.form.signId, '', (res) => {
          this.applyInfo = res.vo

          this.form.dldw = this.applyInfo.dldw
          this.form.content = this.applyInfo.content
          this.form.mode = this.applyInfo.mode
          this.form.type = this.applyInfo.type

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString()

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, 30, this.form.type / 1)
          this.formLoading = false
        })
      },
      // 获取项目详情
      getcontract() {
        ajax.get('/contract/info/' + this.form.contractId, '', (res) => {
          this.contract = res.vo
          this.contract.depId = this.contract.departmentVO.id
          this.contract.deptName = this.contract.departmentVO.name
        })
      },
      // 提交项目招标文件
      createcontract() {
        this.form = this.$refs.create.getFromData()
        if (this.form.underLine == "") {
          this.$message.error('请标注本次审批是否已线下通过')
          return
        }

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()

        console.log(this.form.approvalUserIds)
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.signId ? '/gc/project/invitesign' : '/gc/project/invitesign/edit'

        ajax.post(_url, this.form, (res) => {
          this.$message.success("项目招标文件审批提交成功，请耐心等待领导审批")
          this.$router.back()
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'form.type'() {
        this.approvalUsersData = this.approvalUsers['c10_' + this.form.type]
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/contract/createInviteApproval.vue